<template>
    <el-row class="infor-box" :class="[isFix?'fixWidth':'',title=='高考课堂'?'infor-box1':'']">
        <el-row type="flex" justify="flex-end">
            <el-col :span="16">
                <h2>{{title}}</h2>
            </el-col>
            <el-col :span="8" class="infor-right">
                <a v-if="isShow == true" @click="linkHandler">查看全部<i class="el-icon-arrow-right"></i></a>
            </el-col>
        </el-row>
        <slot name='content'></slot>
    </el-row>
</template>

<script>
export default {
    props: ['title','isShow','isFix'],
    data() {
        return {
        };
    },
    methods: {
        linkHandler() {
            if(this.title == "职业智能评测") {
                this.$router.push({
                    path: '/evaluation'
                })
            } else if(this.title == "大学排行") {
                this.$router.push({
                    path: '/rank'
                })
            }  else if(this.title == "高考课堂") {
                this.$router.push({
                    path: '/video'
                })
            }  else if(this.title == "推荐大学") {
                this.$router.push({
                    path: '/school'
                })
            } else {
                this.$router.push({
                    path: '/news'
                })
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables.scss";
    .fixWidth {
        @include gwidth;
    }
    .infor-box1 {
        padding-right: 0!important;
        // .infor-right {
        //     margin-right: 24px;
        // }
    }
    .infor-box {
        margin-top: 48px;
        height: auto;
        .infor-right {
            text-align: right;
            margin-top: -4px;
        }
        h2 {
            border-left: 2px solid $common-color;
            border-radius: 1px;
            font-size: 22px;
            font-weight: 600;
            color: #2c2e33;
            padding-left: 8px;  
            text-align: left;  
            padding-bottom: 0px; 
            margin-bottom: 32px;
            margin-top: 0;
        }
        a {
            display: inline-block;
            text-decoration:none;
            color: #999390;
            font-size: 14px;
            cursor: pointer;
            width: 95px!important;
            height: 30px!important;
            border: 1px solid #ccc6c4;
            border-radius: 8px;
            text-align: center;
            line-height: 30px;
        }
        .el-icon-arrow-right {
            font-size: 14px;
            left: 3px;
            position: relative;
            color: #c4c7cc;
        }
        a:hover {
            border: 1px solid $common-color;
            color: $common-color;
            .el-icon-arrow-right {
                color: $common-color;
            }
        } 
    }
</style>